import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PauseMenuComponent } from './pause-menu.component';
import { RouterModule } from '@angular/router';
import { PigMenuModule } from '../../svg-components/pig-menu/pig-menu.module';

@NgModule({
  declarations: [PauseMenuComponent],
  exports: [PauseMenuComponent],
  imports: [CommonModule, RouterModule, FormsModule, PigMenuModule],
})
export class PauseMenuModule {}
